module.exports = __webpack_public_path__ + "sx10-1831b074.png";